<!-- Top right, under the profile. A deck: the newest in front, two older ones peeking out below it. Hovering it,
     or tabbing into it, opens it into a list and holds every timer. -->
<div class="fixed z-[1100] top-[72px] right-4 w-[min(380px,calc(100vw-32px))] leading-snug pointer-events-none"
     aria-live="polite" (mouseenter)="hover(true)" (mouseleave)="hover(false)"
     (pointerdown)="pressed()" (focusin)="focusIn()" (focusout)="focusOut($event)">
  <div *ngFor="let n of notify.notices(); let i = index; trackBy: trackById" #card [attr.data-id]="n.id"
       animate.enter="notify-in" animate.leave="notify-out"
       [attr.role]="n.kind === 'error' ? 'alert' : 'status'"
       class="notice absolute inset-x-0 top-0 origin-top pointer-events-auto flex items-center gap-2.5 pl-3 pr-1.5 py-2 rounded-xl shadow-[0_8px_22px_rgba(17,24,39,0.22)] transition-[transform,opacity] duration-200 ease-out motion-reduce:transition-none after:absolute after:inset-x-0 after:top-full after:h-2.5 after:content-['']"
       [ngClass]="look(n.kind).card" [class.behind]="behind(i)"
       [style.transform]="place(i)" [style.opacity]="hidden(i) ? 0 : null" [style.z-index]="max - i">
    <span class="w-[26px] h-[26px] shrink-0 rounded-full flex items-center justify-center" [ngClass]="look(n.kind).badge">
      <span class="material-icons" style="font-size: 16px">{{ look(n.kind).icon }}</span>
    </span>
    <span class="flex-1 min-w-0 text-[13px]" [ngClass]="look(n.kind).text">
      <span class="font-semibold">{{ n.title }}</span>
      <span *ngIf="n.detail" [ngClass]="look(n.kind).detail"> · {{ n.detail }}</span>
    </span>
    <button *ngIf="n.action" type="button" (click)="notify.act(n.id)"
            class="h-8 px-2.5 rounded-md text-[12.5px] font-semibold whitespace-nowrap" [ngClass]="look(n.kind).action">
      {{ n.action.label }}
    </button>
    <button type="button" (click)="notify.dismiss(n.id)" aria-label="Close"
            class="w-8 h-8 shrink-0 rounded-md flex items-center justify-center" [ngClass]="look(n.kind).close">
      <span class="material-icons" style="font-size: 16px">close</span>
    </button>
  </div>
</div>
